
import { Layout } from "@/components/Layout/Layout";

export default function Terms() {
  return (
    <Layout>
      <div className="container max-w-4xl py-12 px-4 mx-auto animate-fade-in">
        <h1 className="text-3xl font-bold mb-6">Terms & Conditions</h1>
        
        <div className="prose prose-sm sm:prose max-w-none">
          <h2>1. Introduction</h2>
          <p>Welcome to ThePromptSpace. By accessing or using our platform, you agree to be bound by these Terms and Conditions and our Privacy Policy.</p>
          
          <h2>2. Definitions</h2>
          <p>"User", "You", or "Your" refers to individuals who access or use ThePromptSpace.</p>
          <p>"Service", "Platform", "ThePromptSpace", "We", "Us", or "Our" refers to the ThePromptSpace platform and its operators.</p>
          
          <h2>3. User Accounts</h2>
          <p>You may be required to create an account to use certain features of our Service. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.</p>
          
          <h2>4. User Content</h2>
          <p>Users may share AI prompts, comments, and other content on our platform. You retain ownership of your content, but grant ThePromptSpace a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, adapt, publish, and display such content in connection with providing and promoting the Service.</p>
          
          <h2>5. Prohibited Content</h2>
          <p>You agree not to share content that is illegal, harmful, threatening, abusive, harassing, tortious, defamatory, vulgar, obscene, or invasive of another's privacy.</p>
          
          <h2>6. Intellectual Property</h2>
          <p>Our Service and its original content, features, and functionality are owned by ThePromptSpace and are protected by international copyright, trademark, and other intellectual property laws.</p>
          
          <h2>7. Termination</h2>
          <p>We may terminate or suspend your account and access to the Service immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users of the Service, us, or third parties, or for any other reason.</p>
          
          <h2>8. Limitation of Liability</h2>
          <p>In no event shall ThePromptSpace be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or goodwill, arising out of or in connection with your access to, use of, or inability to use the Service.</p>
          
          <h2>9. Changes to Terms</h2>
          <p>We reserve the right to modify these Terms at any time. We will provide notice of significant changes by posting a notice on our Service or by sending you an email.</p>
          
          <h2>10. Governing Law</h2>
          <p>These Terms shall be governed by the laws of the jurisdiction in which ThePromptSpace is established, without regard to its conflict of law provisions.</p>
          
          <h2>11. Contact Information</h2>
          <p>For questions about these Terms, please contact us at support@thepromptspace.com.</p>
          
          <p className="text-sm text-muted-foreground mt-8">Last updated: April 4, 2025</p>
        </div>
      </div>
    </Layout>
  );
}
